import { useNavigate } from "react-router-dom";
import LazyImage from "../../../LazyImg/LazyImage";
import AboutUsImg from "../../../assets/HomeAssets/aboutUsSection.webp";
const digitalOceanURL =
  "https://hirestarorg.blr1.digitaloceanspaces.com/Hirestar-Landing-Page/assets";
const About_Image = `${digitalOceanURL}/about.png`;

const AboutSection = () => {
  const navigate = useNavigate();

  const handleReadMoreClick = () => {
    navigate("/about-us");
  };
  // console.log("about section");
  return (
    <div className="">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center justify-center max-w-[1400px] mx-auto">
        {/* Text Section */}
        <div className="text-center lg:text-left px-4 lg:px-6">
          <button
            className="bg-[#dcf4ff] px-4 py-1 mb-4 rounded-full text-[#0d6eb5] border border-[#137bbf] font-medium text-base"
            aria-label="About Us"
          >
            ABOUT US
          </button>

          <h2 className="font-semibold text-[32px] md:text-[40px] lg:text-[48px] leading-tight mb-4 About-Heading">
            Hirestar.io: Leading Transparent, Tamper-Proof, Fast Background
            Checks
          </h2>

          <p className="font-[poppins] text-[16px] text-gray-700 mb-6">
            Hirestar.io is a background verification company powered by
            blockchain. AI & Blockchain technology enables us to reduce turnaround
            times, ensure complete transparency, and provide tamper-proof
            reports, making us a leader in this industry (background
            verification companies, background verification vendors, and
            background checks companies).
          </p>

          <button
            className="rounded-full text-white lg:px-4 lg:py-3 md:px-4 md:py-3 px-3 py-2 Read-More-btn font-base"
            onClick={handleReadMoreClick}
          >
            Read More
          </button>
        </div>

        {/* Image Section */}
        <div className="flex justify-center lg:justify-end">
          <img
            src={AboutUsImg}
            alt="About Hirestar.io section"
            title="Hirestar-About-Image"
            className="w-full max-w-md lg:max-w-lg h-auto object-contain"
          />
        </div>
      </div>
    </div>
  );
};

export default AboutSection;
